import { Controller } from '@hotwired/stimulus';
import { useWindowResize } from 'stimulus-use'

/* stimulusFetch: 'lazy' */
export default class extends Controller {
  static targets = ['banner', 'header', 'nav', 'anchors'];
  navTop = 0;
  navHeight = 0;
  bannerHeight = 0;
  headerHeight = 0;
  adminBarHeight = 0;

  connect() {
    if (this.hasBannerTarget) {
      this.bannerHeight = this.bannerTarget.offsetHeight;
      this.navTop = this.navTarget.offsetTop;
      this.navHeight = this.navTarget.offsetHeight;
      this.headerHeight = this.headerTarget.offsetHeight;
      if (document.getElementById('wpadminbar')) {
        this.adminBarHeight = document.getElementById('wpadminbar').offsetHeight;
      }
      useWindowResize(this);
    }
  }

  onScroll() {
    if (this.hasBannerTarget) {
      if (window.innerWidth < 1200) {
        if (window.scrollY <= this.bannerHeight) {
          if (this.hasAnchorsTarget) {
            this.anchorsTarget.style.top = this.navTop - window.scrollY + 'px';
          }
        } else {
          if (this.hasAnchorsTarget) {
            this.anchorsTarget.style.top = this.headerHeight + this.adminBarHeight + 'px';
          }
        }
      } else {
        if (this.hasAnchorsTarget) {
          this.anchorsTarget.style = '';
        }
      }
    }
  }

  windowResize() {
    this.onScroll();
  }
}